import styled from '@emotion/styled'
import { breakpoints, fonts } from 'src/utils/styles'

export const PageLayout = styled.div`
  display: grid;
  grid-template-columns: 0.5fr 4fr;
  font-family: ${fonts.regular};
  @media (max-width: ${breakpoints.l}px) {
    grid-template-columns: 1fr;
  }
`
